<div class="icon" [inlineSVG]="type | messageBoxIcon"></div>

<div *ngIf="!messages" class="message">
  <ng-content></ng-content>
</div>

<ul *ngIf="messages">
  <li *ngFor="let message of messages" [innerHTML]="message | safeHtml"></li>
</ul>
